export enum TrackingEventType {
  PageView = 'pageview',
  Click = 'click'
}
